export const API_STATUS = {
  IDLE: 'Idle',
  PENDING: 'Pending',
  SUCCESS: 'Success',
  FAILED: 'Failed',
};
